module.exports = __webpack_public_path__ + "static/media/pizza.25bb3454.svg";